<template>
  <b-container>
    <h1 v-translate>Company Area</h1>
    <hr>
    <div class="row">
      <div class="col-md-3">
        <company-navigation />
      </div>
      <div class="col-md-9 company-profile">
        <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
          <h5 class="mb-0" v-translate>Company Settings updated!</h5>
        </b-alert>
        <h3 v-translate>Company Settings</h3>
        <b-row>
          <b-col cols="12">
            <h4 class="mt-3" v-translate>General</h4>
            <b-form class="mt-3" @submit.prevent.stop="updateCompanySetting(companySetting)" v-for="(companySetting, index) in company.settings" :key="index">
              <div v-if="companySetting.data_type === 'switch'">
                <b-form-checkbox size="lg" switch v-model="company.settings[index].companySetting.value" value="1" unchecked-value="0" @input="updateCompanySetting(companySetting)">
                  {{companySetting.description}}
                </b-form-checkbox>
              </div>
              <div v-if="companySetting.data_type === 'ip_ranges'">
                <label :for="'company-setting-' + companySetting.id" class="d-block">{{ companySetting.description }}</label>
                <div v-for="(elem, index2) in company.settings[index].companySetting.value" v-if="companySetting.companySetting" :key="index2">
                  <input-ip placeholder v-model="company.settings[index].companySetting.value[index2]" :ip="company.settings[index].companySetting.value[index2].split('/')[0]" :port="company.settings[index].companySetting.value[index2].split('/')[1] || ''" theme="material" />
                  <b-button size="sm" class="py-0 px-2" variant="danger" @click.prevent="company.settings[index].companySetting.value.splice(index2, 1)" v-show="companySetting.companySetting.value.length > 1">
                    ×
                  </b-button>
                  <b-button size="sm" class="py-0 px-2" variant="success" @click.prevent="company.settings[index].companySetting.value.push(''); " v-show="index2 + 1 === companySetting.companySetting.value.length">
                    +1
                  </b-button>
                </div>
                <b-input-group-append class="mt-1">
                  <b-button size="sm" class="py-1 px-3" variant="secondary" type="submit" v-if="company.settings[index].companySetting.id" v-translate>
                    Update
                  </b-button>
                  <b-button size="sm" class="py-1 px-3" variant="secondary" type="submit" v-else v-translate>
                    Set
                  </b-button>
                  <b-button size="sm" class="py-1 px-3" variant="danger" @click="deleteCompanySetting(companySetting)" v-if="company.settings[index].companySetting.id" v-translate>
                    Delete
                  </b-button>
                </b-input-group-append>
              </div>
              <div v-if="companySetting.data_type === 'number' || companySetting.data_type === 'string'">
                <label :for="'company-setting-' + companySetting.id" class="d-block">{{ companySetting.name }}</label>
                <b-input-group>
                  <b-form-input class="w-auto" v-model="company.settings[index].companySetting.value" :type="companySetting.data_type === 'number' ? 'number' : 'text'" :step="companySetting.data_type === 'number' ? '.01' : null"
                    required />
                  <b-input-group-append>
                    <b-input-group-text v-if="companySetting.name.indexOf('percentage') !== -1">
                      %
                    </b-input-group-text>
                    <b-button size="sm" variant="secondary" type="submit" v-if="companySetting.companySetting.id" v-translate>
                      Update
                    </b-button>
                    <b-button size="sm" variant="secondary" type="submit" v-else v-translate>
                      Set
                    </b-button>
                    <b-button size="sm" variant="danger" @click="deleteCompanySetting(companySetting)" v-if="companySetting.companySetting.id" v-translate>
                      Delete
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-form-text>{{companySetting.description}}</b-form-text>
              </div>
            </b-form>
          </b-col>
        </b-row>
        <hr class="my-4">
        <form @submit.prevent="updateCompany">
          <h4 class="mt-4" v-translate>After Delivery Survey</h4>
          <p v-translate="{courierI18n: this.courierI18n}">Here you can specify a Survey URL which will be displayed on screen after delivery for the receiver to complete it. It may have querystring or hash URL static or dynamic params (ie.: shipping ID, %{courierI18n} ID, receiver name, etc.) to help you deal with data results.</p>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <h5 v-translate>Survey URL</h5>
                <b-form-input
                  v-model="visibleUrl"
                  type="url"
                  :formatter="surveyUrlFormatter"
                  :state="validUrl"
                ></b-form-input>
                <b-form-text v-translate class="text-muted mb-2">Complete and valid URL to the survey (ie.: https://surveysite.com/surveyid)</b-form-text>
              </b-form-group>
              <h5><translate>Survey URL Parameters</translate> <b-button variant="primary" size="sm" @click="paramPairs.push(Object.assign({}, paramModel))" v-translate :disabled="!validUrl || notEmptyParams">Add param</b-button></h5>
              <div class="row" v-for="(paramField, index) in paramPairs" :key="index">
                <div class="form-group col-md-4">
                  <label class="control-label" v-translate>Param Key</label>
                  <input class="form-control col-md-12" type="text" v-model="paramPairs[index].paramKey" :required="paramPairs[index].paramValue.length > 0" :disabled="!validUrl">
                </div>
                <div class="form-group col-md-6">
                  <label class="control-label" v-translate>Param Value</label>
                  <b-form-select
                    :options="availableParams"
                    class="form-control col-md-12"
                    type="text"
                    v-model="paramPairs[index].paramValue"
                    :required="paramPairs[index].paramKey.length > 0"
                    :disabled="!validUrl || !paramPairs[index].paramKey"
                    v-if="availableParams.findIndex(x => x.value === paramPairs[index].paramValue) !== -1 || paramPairs[index].paramValue === ''"
                  >
                    <template #first>
                      <b-form-select-option value="" disabled  v-translate>-- Please select an option --</b-form-select-option>
                      <b-form-select-option value="custom" v-translate>Custom</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-input v-model="paramPairs[index].paramValue"
                    type="text"
                    :disabled="!validUrl || !paramPairs[index].paramKey"
                    v-else
                  ></b-form-input>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label text-white">&nbsp;</label><br>
                  <b-button variant="primary" size="sm" @click="clearParam(index)" v-translate :disabled="!validUrl">Remove</b-button>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-button variant="primary" type="submit" class="mt-3">
            <translate>Update Survey Settings</translate>
          </b-button>
          <hr class="my-4">
        </form>
      </div>
    </div>
  </b-container>
</template>

<script>
import { FETCH_PROFILE } from '@/store/actions.type'
import CompanyNavigation from '@/components/CompanyNavigation'
import InputIp from '@/components/InputIp'

export default {
  name: 'CompanySettings',
  title() {
    return this.$gettext('Company Settings')
  },
  components: {
    CompanyNavigation,
    InputIp
  },
  data() {
    return {
      company: {
        survey: {
          url: '',
          params: []
        },
        settings: []
      },
      paramPairs: [],
      paramModel: {
        paramKey: '',
        paramValue: ''
      },
      availableParams: [
        {
          text: this.$gettext('Shipping ID'),
          value: '!id!'
        },
        {
          text: this.$gettextInterpolate('%{courierI18n} ID', this.courierI18n),
          value: '!courier_id!'
        },
        {
          text: this.$gettext('Internal ID'),
          value: '!external_id!'
        },
        {
          text: this.$gettext('Internal Order ID'),
          value: '!external_order_id!'
        },
        {
          text: this.$gettext('Receiver Name'),
          value: '!to_name!'
        }
      ],
      oldParams: '',
      visibleUrl: '',
      publicSettings: [],
      companySettings: [],
      dismissSecs: 10,
      dismissCountDown: 0
    }
  },
  watch: {
    visibleUrl(val) {
      this.company.survey.url = val
    },
    'company.survey.url': {
      handler (val) {
        let parsedUrl = new URL(val)
        this.paramPairs = []
        if (parsedUrl.search) {
          parsedUrl.searchParams.forEach(function (value, key) {
            this.paramPairs.push({
              paramKey: key,
              paramValue: value
            })
          }.bind(this))
        } else if (parsedUrl.hash) {
          // HACK: to easily deal with hash params treating them as normal querystring
          val = val.replace('#', '?')
          parsedUrl = new URL(val)
          this.paramPairs = []
          if (parsedUrl.searchParams) {
            parsedUrl.searchParams.forEach(function (value, key) {
              this.paramPairs.push({
                paramKey: key,
                paramValue: value
              })
            }.bind(this))
          }
          // HACK: and back to hash again
          val = val.replace('?', '#')
        } else {
          this.paramPairs.push({...this.paramModel})
        }
        this.visibleUrl = val
      },
      deep: true
    },
    paramPairs: {
      handler (val) {
        if (this.oldParams !== '' && this.oldParams !== JSON.stringify(val)) {
          let params = new URLSearchParams()
          for (let i = 0; i < val.length; i++) {
            params.append(val[i].paramKey, val[i].paramValue)
          }
          let parsedUrl = new URL(this.company.survey.url)
          parsedUrl.search = params.toString()
          this.company.survey.url = parsedUrl.origin + (parsedUrl.pathname === '/' ? '' : parsedUrl.pathname) + (parsedUrl.hash ? this.surveyUrlFormatter(parsedUrl.search).replace('?', '#') : this.surveyUrlFormatter(parsedUrl.search))
        }
        this.oldParams = JSON.stringify(val)
      },
      deep: true
    }
  },
  computed: {
    validUrl() {
      try {
        const parsedUrl = new URL(this.company.survey.url) || false
        if (parsedUrl) {
          return parsedUrl && parsedUrl.origin.length > 0
        }
      } catch (e) {
        if (this.company.survey.url.length === 0) {
          return null
        }
        return false
      }
    },
    notEmptyParams() {
      return this.paramPairs.findIndex(x => x.paramKey === '' || x.paramValue === '') !== -1
    }
  },
  mounted() {
    this.getCompany()
  },
  methods: {
    getCompany() {
      this.$store.dispatch(FETCH_PROFILE)
        .then(response => {
          if (this.$store.getters.profile.company.survey && this.$store.getters.profile.company.survey.url) {
            this.company.survey.url = this.visibleUrl = this.$store.getters.profile.company.survey.url
          } else {
            this.paramPairs.push(this.paramModel)
          }
          this.$http.get(this.$appConfig.api.baseUrl + 'settings/public')
            .then(settings => {
              this.publicSettings = settings.body.data
              this.company.settings = []
              this.$nextTick(() => {
                this.company.settings = [...new Set(this.publicSettings.map(x => {
                  x.companySetting = response.company.settings.length > 0 && response.company.settings.findIndex(y => x.name === y.name) !== -1
                    ? response.company.settings.find(y => x.name === y.name).pivot
                    : {
                      value: x.data_type === 'ip_ranges' ? ['...'] : '',
                      setting_id: x.id,
                      company_id: response.company.id,
                      id: response.company.settings.length > 0 && response.company.settings.findIndex(y => x.name === y.name) !== -1 ? response.company.settings.find(y => x.name === y.name).id : null
                    }
                  x.companySetting.id = response.company.settings.length > 0 && response.company.settings.findIndex(y => x.name === y.name) !== -1 ? response.company.settings.find(y => x.name === y.name).id : null
                  try {
                    x.companySetting.value = x.data_type === 'ip_ranges' ? JSON.parse(x.companySetting.value) : x.companySetting.value
                  } catch (e) {
                    console.log(e)
                  }
                  return x
                }))]
              })
            })
        })
    },
    setCompanySettings() {

    },
    surveyUrlFormatter(value) {
      console.log(value)
      value = value.replace('?=', '')
      return value.replace(/%21/g, '!')
    },
    cleanUpSurveyUrl(value) {
      // value.replace(/\?=/g, '')
      return value.replace(/&=/g, '')
    },
    updateCompany() {
      const extractParamsRegexp = /!([^!]+)!/g
      this.company.survey.params = [...this.company.survey.url.matchAll(extractParamsRegexp)].map(x => { return x[1] })
      console.log(this.company.survey)
      this.$http.patch(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company_id, this.company)
        .then(response => {
          this.getCompany()
          this.showAlert()
        })
    },
    clearParam(index) {
      if (this.paramPairs.length > 1) {
        this.paramPairs.splice(index, 1)
      } else {
        this.paramPairs = []
        this.paramPairs.push(this.paramModel)
      }
    },
    updateCompanySetting(setting) {
      // Cleanup empty IP ranges
      if (Array.isArray(setting.companySetting.value)) {
        setting.companySetting.value = setting.companySetting.value.map(x => {
          if (x && x !== '...') {
            return x
          }
        }).filter(Boolean)
      }
      if (!setting.companySetting.id) {
        this.$http.post(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company_id + '/settings/' + setting.companySetting.setting_id, setting.companySetting)
          .then(response => {
            this.getCompany()
            this.showAlert()
          })
      } else {
        this.$http.patch(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company_id + '/settings/' + setting.companySetting.setting_id, setting.companySetting)
          .then(response => {
            this.getCompany()
            this.showAlert()
          })
      }
    },
    deleteCompanySetting(setting) {
      if (confirm(this.$gettext('Are your sure you want to DELETE this Company Setting?'))) {
        this.$http.delete(this.$appConfig.api.baseUrl + 'companies/' + this.$store.getters.profile.company_id + '/settings/' + setting.companySetting.setting_id)
          .then(response => {
            this.getCompany()
            this.showAlert()
          })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
